var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconOrgPaysTertiary = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.364 3v.529h2.872v16.942H2.749V3.529h2.87L5.622 3h5.743zM7.918 14.824H4.472v3.388h3.446v-3.388zm4.595 0H9.067v3.388h3.446v-3.388zm-4.595-4.518H4.472v3.388h3.446v-3.388zm4.595 0H9.067v3.388h3.446v-3.388zM7.918 5.788H4.472v3.388h3.446V5.788zm4.595 0H9.067v3.388h3.446V5.788zM20.554 6v.705h2.297v13.766h-8.328V6.705h1.436V6h4.595zm-2.757 9.882H15.04v2.753h2.757v-2.753zm3.676 0h-2.757v2.753h2.757v-2.753zm-3.676-3.67H15.04v2.753h2.757v-2.753zm3.676 0h-2.757v2.753h2.757v-2.753zm-3.676-3.67H15.04v2.752h2.757V8.541zm3.676 0h-2.757v2.752h2.757V8.541zM1.6 20.471H24V21.6H1.6z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconOrgPaysTertiary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-org-pays-tertiary.5b005ee0b1ae966e78b29dda0a8d3038.svg";